<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width"
						:event="item.event" @invClass="getHelperLevel3">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarydealerfilestable :tableData="tableData" :total="total" @Export="customerExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarydealerfilestable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Secondarydealerfilestable from "./components/secondarydealerfilestable.vue";

	import {
		GetOrganizationRebateList,
		ExportOrganizationRebate,
		GetHelperLevel3,
	} from "@/api/newsapi";
	import {
		InventoryClassList
	} from '@/api/home'
	import utils from "../../../common/utils";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarydealerfilestable,
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				form: {},
				formdata: [{
						inputdata: "",
						title: "产品线",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "select",
						width: "220px",
						lablewith: "117px",
						options: [],
						event: "invClass",
					},
					{
						inputdata: "",
						title: "LEVEL3",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "select",
						width: "220px",
						lablewith: "117px",
						options: []
					},
					{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "创建时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "date",
						inputtype: "date",
						width: "220px",
						lablewith: "117px",
					}
				],
			};
		},
		mounted() {
			this.inventoryClassList();
			this.customerList();
		},
		methods: {
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[0].options.push(obj)
					})
				}
			},
			//获取l3数据
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({
					InvClass: this.$refs.seselect[0].modelvalue
				});
				if (code == 0) {
					this.$refs.seselect[1].modelvalue = '';
					this.formdata[1].options = [];
					data.map((item, index) => {
						this.formdata[1].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			// 列表
			async customerList() {
				let {
					data,
					code
				} = await GetOrganizationRebateList({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data.map(it => {
						it.StartDate = it.StartDate ? it.StartDate.substring(0, 10) : '';
						it.EndDate = it.EndDate ? it.EndDate.substring(0, 10) : '';
						return it;
					});
				}
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
					if (index === 3) {
						item.startTime = "";
						item.endTime = "";
					}
				});
			},
			select() {
				this.pageindex = 1;
				this.form.InvClass = this.$refs.seselect[0].modelvalue;
				this.form.LEVEL3 = this.$refs.seselect[1].modelvalue;
				this.form.CusName = this.$refs.seselect[2].modelvalue;
				this.form.CreateTime1 = this.$refs.seselect[3].startTime;
				this.form.CreateTime2 = this.$refs.seselect[3].endTime;
				this.customerList();
			},
			// 导出
			async customerExport() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportOrganizationRebate({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				loading.close();
				if (resexprot) {
					utils.downloadFile(resexprot, "组织返利报表", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.customerList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.customerList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 125px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>